export default class OperatingHoursLimitRequest {
    
    public reportDate: Date  = new Date();

    public deviceId: string | null  = null;
    
    public odometerNumber: number | null = null;
}